"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOKIA = [
    { deviceName: 'Nokia 1 Plus', brandName: 'Nokia', deviceCode: 'Nokia 1 Plus' },
    { deviceName: 'Nokia 1', brandName: 'Nokia', deviceCode: 'Nokia 1' },
    { deviceName: 'Nokia 2.1', brandName: 'Nokia', deviceCode: 'Nokia 2.1' },
    { deviceName: 'Nokia 2.2', brandName: 'Nokia', deviceCode: 'Nokia 2.2' },
    { deviceName: 'Nokia 2', brandName: 'Nokia', deviceCode: 'Nokia 2' },
    { deviceName: 'Nokia 3.1 Plus', brandName: 'Nokia', deviceCode: 'Nokia 3.1 Plus' },
    { deviceName: 'Nokia 3.1', brandName: 'Nokia', deviceCode: 'Nokia 3.1' },
    { deviceName: 'Nokia 3.2', brandName: 'Nokia', deviceCode: 'Nokia 3.2' },
    { deviceName: 'Nokia 4.2', brandName: 'Nokia', deviceCode: 'Nokia 4.2' },
    { deviceName: 'Nokia 5.1 Plus', brandName: 'Nokia', deviceCode: 'Nokia 5.1 Plus' },
    { deviceName: 'Nokia 5.1', brandName: 'Nokia', deviceCode: 'Nokia 5.1' },
    { deviceName: 'Nokia 6.1 Plus', brandName: 'Nokia', deviceCode: 'Nokia 6.1 Plus' },
    { deviceName: 'Nokia 6.1', brandName: 'Nokia', deviceCode: 'Nokia 6.1' },
    { deviceName: 'Nokia 6.2', brandName: 'Nokia', deviceCode: 'Nokia 6.2' },
    { deviceName: 'Nokia 7 Plus', brandName: 'Nokia', deviceCode: 'Nokia 7 Plus' },
    { deviceName: 'Nokia 7.1', brandName: 'Nokia', deviceCode: 'Nokia 7.1' },
    { deviceName: 'Nokia 7.2', brandName: 'Nokia', deviceCode: 'Nokia 7.2' },
    { deviceName: 'Nokia 8.1', brandName: 'Nokia', deviceCode: 'Nokia 8.1' },
    { deviceName: 'Nokia 8 Sirocco', brandName: 'Nokia', deviceCode: 'Nokia 8 Sirocco' },
    { deviceName: 'Nokia 8', brandName: 'Nokia', deviceCode: 'Nokia 8' },
    { deviceName: 'Nokia 9 PureView', brandName: 'Nokia', deviceCode: 'Nokia 9 PureView' }
];
//# sourceMappingURL=nokia.js.map